import { Component, inject, ChangeDetectionStrategy } from "@angular/core";
import { tap } from "rxjs/operators";
import { GroupItemModel } from "../group.interface";
import { LorenAssetService } from "../../../../features/loren-assets/services/loren-asset-service/loren-asset.service";
import { LorenAsset } from "../../../../features/loren-assets/interfaces/loren-asset.interface";
import {DialogBase} from "../../../../common/dialog/dialog.base";

@Component({
    selector: "loren-hierarchy-modification-dialog",
    templateUrl: "./hierarchy-modification-dialog.component.html",
    styleUrls: ["./hierarchy-modification-dialog.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class HierarchyModificationDialogComponent extends DialogBase<{ node: GroupItemModel; }, HierarchyModificationDialogData>{
  private assetService = inject(LorenAssetService);

  assets$ = this.assetService.lastCachedAssets$.pipe(
    tap((x) => {
      this.dialogData.selectedAssets = this.data.node.childGroups
        .filter((g) => g.isAsset)
        .map((g) => x.find((s) => s.id === g.id));

      setTimeout(() => this.refreshSaveBtnState(), 1);
    })
  );

  dialogData: HierarchyModificationDialogData = {
    action: !this.data.node.isRoot ? "editGroup" : "addGroup",
    selectedAssets: [],
    newGroupName: null,
    newGroupDescription: null,
  };

  nameChanged = false;
  descriptionChanged = false;
  disableSaveButton = true;

  currentName = this.data.node.name;
  currentDescription = this.data.node.description;

  cancel(): void {
    this.data.node.name = this.currentName;
    this.data.node.description = this.currentDescription;
    this.dialogRef.close();
  }

  save() {
    this.dialogRef.close(this.dialogData);
  }

  refreshSaveBtnState() {
    this.disableSaveButton =
      (this.dialogData.action === "addGroup" &&
        !this.dialogData.newGroupName) ||
      (this.dialogData.action === "addAsset" &&
        this.dialogData.selectedAssets.length === 0) ||
      (this.dialogData.action === "editGroup" &&
        !this.nameChanged &&
        !this.descriptionChanged);
  }
}

export interface HierarchyModificationDialogData {
  action: "addAsset" | "addGroup" | "editGroup";
  selectedAssets: LorenAsset[];
  newGroupName: string;
  newGroupDescription: string;
}
